import { Component, EventEmitter, Input, Output, ViewEncapsulation, input } from '@angular/core';
import { SHARED_IMPORTS } from '../../shared-imports';
import { Button } from '../button/button.component';

@Component({
  selector: 'app-question-page',
  imports: [SHARED_IMPORTS, Button],
  templateUrl: './question-page.html',
  styleUrl: './question-page.scss',
  // eslint-disable-next-line no-view-encapsulation-none/no-view-encapsulation-none
  encapsulation: ViewEncapsulation.None,
})
export class QuestionPage {
  backLabelKey = input<string>('navigationButtons.back');
  nextLabelKey = input<string>('navigationButtons.next');
  completeLabelKey = input<string>('navigationButtons.complete');

  @Input() showBackButton = true;
  @Input() showNextButton = true;
  @Input() disableNextButton = false;
  /**
   * If true, the next button will display as "Complete" instead of "Next".
   */
  @Input() isCompleteStep = false;
  @Output() readonly backClick = new EventEmitter<void>();
  @Output() readonly nextClick = new EventEmitter<void>();
}
